import {defineMessages} from 'react-intl';

export default defineMessages({
	youMayAlsoLike: {
		id: 'productRecommendations.youMayAlsoLike',
		defaultMessage: 'You May Also Like',
	},
	styleItWith: {
		id: 'productDetail.styleItWith',
		defaultMessage: 'Style With',
	},
	recentlyViewed: {
		id: 'productRecommendations.recentlyViewed',
		defaultMessage: 'Recently Viewed',
	},
	recommendations: {
		id: 'productRecommendations.recommended',
		defaultMessage: 'Recommended',
	},
});
